import React, { Component } from 'react';
import PropTypes from 'prop-types';
import  '../../../containers/AdminConfig/css/AdminConfig.css';
import ModalConfirmUserInformation from '../../../Modals/ModalConfirmUserInformation';
import ModalConfirmPassword from '../../../Modals/ModalConfirmPassword';
import AlertBar from '../../../Modals/AlertBar';
import { AlertConfirm } from '../../../Modals/AlertBar';
import { withNamespaces } from 'react-i18next'


class UserInfomation extends Component {
    constructor() {
        super();

        this.state = {
            userName: '',
            firstName: '',
            lastName: '',
            mobile: '',
            email: '',
            companyName: '',
            dailyReport: false,
            password: '',
            telephone: '',
            lineApiToken: '',
            isSendDailyReport: false,
            showModalChangePassword: false,
            showModalConfirmUserInformation: false,
            logInName: '',
            notification: false
        };
    }

    componentDidMount() {
        this.getDriverInformation();
    }

    componentWillUnmount() {
        this.setState({});
    }

    getDriverInformation() {
        const {
            user_name,
            user_id,
            token
        } = this.props;
        fetch(`http://203.150.199.244/api/admin/getUserInfo/${user_id}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({})
            })
            .then(response => response.json())
            .then(data => {this.setState({
                userName: data.RESULT_DATA[0].login_name,
                firstName: data.RESULT_DATA[0].first_name,
                telephone: data.RESULT_DATA[0].tel_no,
                email: data.RESULT_DATA[0].email,
                companyName: data.RESULT_DATA[0].company_name,
                lineApiToken: data.RESULT_DATA[0].line_api_token,
                isSendDailyReport: data.RESULT_DATA[0].is_send_daily_report,
                logInName: data.RESULT_DATA[0].login_name,
                lastName: data.RESULT_DATA[0].last_name
            })})
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
     }

    onChangeTelePhone(e) {
        this.setState({telephone: e.target.value });
    }

    onChangeEmail(e) {
        this.setState({email: e.target.value });
    }

    handleSubmitChangePassword = () => {
    const { showModalChangePassword } = this.state;
      if (!showModalChangePassword) {
          this.setState({showModalChangePassword: true});
      }
    }

    handleCheckSendDailyReport = () => {
    const { isSendDailyReport } = this.state;
        if (isSendDailyReport) {
            this.setState({isSendDailyReport: false});
        } else {
            this.setState({isSendDailyReport: true});
        }
    }

    handleSubmitUpdateUserInformation = () => {
        this.setState({showModalConfirmUserInformation: true});
    }

    onClickCancelUserInformation = (status) => {
        this.setState({ showModalConfirmUserInformation: status });
    }

    onClickConfirmUserInformation = () => {
        AlertConfirm("แก้ไขการจัดการข้อมูล"," ").then(isOk=>{
            if(isOk) {
                const {
                    user_name,
                    user_id,
                    token
                } = this.props;

                const {
                    userName,
                    firstName,
                    lastName,
                    telephone,
                    email,
                    companyName,
                    lineApiToken,
                    isSendDailyReport
                } = this.state;

                window.scrollTo(0, 0);
                fetch(`http://203.150.199.244/api/admin/updateDealer/${user_id}`, {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        // "user_id": user_id,
                        // "user_name": user_name,
                        "token": token
                    },
                    body: JSON.stringify({
                        "create_user": userName,
                        "login_name": userName,
                        "first_name": firstName,
                        "last_name": lastName,
                        "tel_no": telephone,
                        "email": email,
                        "company_name": companyName,
                        "line_api_token": lineApiToken,
                        "is_send_daily_report": isSendDailyReport
                    })
                })
                    .then(response => response.json())
                    .then(() => {
                        this.setState({showModalConfirmUserInformation: false, notification: true})
                    })
                    .then(setTimeout(() => {
                        this.setState({notification: false});
                    }, 8000))
                    .then(() => {
                        this.getDriverInformation
                    })
                    // .then(() => {window.scroll(0, 0);})
                    .catch(function (err) {
                        console.log('err:', err);
                        // POST failed...
                    });
            }
        });
    }

    onClickCancelChangePassword = (status) => {
        this.setState({ showModalChangePassword: status });
    }

    onClickConfirmChangePassword = (oldPassword, newPassword, confirmPassword) => {

        AlertConfirm("เปลี่ยนรหัสผ่าน"," ").then(isOk=>{
            if(isOk){
                const {
                    user_name,
                    user_id,
                    token
                } = this.props;

                if (newPassword === confirmPassword) {
                    window.scrollTo(0, 0);
                    fetch(`http://203.150.199.244/api/admin/changePassword/${user_id}/${oldPassword}`, {
                        method: 'post',
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            // "user_id": user_id,
                            // "user_name": user_name,
                            "token": token
                        },
                        body: JSON.stringify({
                            "password": newPassword
                        })
                    })
                        .then(response => response.json())
                        .then(data => {
                            if (data.RESULT_STATUS !== '999') {
                                this.setState({showModalChangePassword: false, notification: true})
                            } else {
                                // console.log('password Error:::::')
                                alert("ยืนบันหรัสผ่านอีกครั้ง");
                            }
                        })
                        .then(setTimeout(() => {
                            this.setState({notification: false});
                        }, 8000))
                        .then(() => {
                            this.getDriverInformation
                        })
                        .catch(function (err) {
                            console.log('err:', err);
                            // POST failed...
                        });
                } else {
                    alert("การยืนยันรหัสผ่านไม่ตรงกับรหัสผ่านเดิม");
                }
            }
        });
    }

  render() {
        const { t } = this.props;
        const {
            userName,
            firstName,
            lastName,
            telephone,
            email,
            companyName,
            lineApiToken,
            showModalChangePassword,
            isSendDailyReport,
            showModalConfirmUserInformation,
            notification
        } = this.state;

      return (
        <div className="gray-panel" >

            {
                notification &&
                /* <Alert className="fade" type="success"  headline="Success!" > */
                /* </Alert> */
                <AlertBar />
            }

                { showModalConfirmUserInformation &&
                <ModalConfirmUserInformation
                    onClickCancelUserInformation={this.onClickCancelUserInformation}
                    onClickConfirmUserInformation={this.onClickConfirmUserInformation}
                />
                }
            <div className="col-md-12">
                    <h1 className="page-header"> <i className="fa fa-user" style={{color: '#7386D5'}} />{t('ข้อมูลผู้ใช้งาน')}</h1>
            </div>
            <hr/>
            <div className="col-md-12">

                <div className="row">
                    <div className="col-md-6">
                        <form>
                        <div className="form-group row">
                            <label htmlFor="example-text-input" className="col-md-3 col-form-label">{t('ชื่อผู้ใช้งาน')}</label>
                            <div className="col-md-9">
                                <input
                                    className="form-control"
                                    type="text"
                                    id="userName"
                                    defaultValue={userName}
                                    onChange={(e) => this.setState({ userName: e.target.value })}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="example-text-input" className="col-md-3 col-form-label">{t('ชื่อ')}</label>
                            <div className="col-md-9">
                                <input
                                    className="form-control"
                                    type="text"
                                    id="firstName"
                                    defaultValue={firstName}
                                    onChange={(e) => this.setState({ firstName: e.target.value })}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="example-text-input" className="col-md-3 col-form-label">{t('นามสกุล')}</label>
                            <div className="col-md-9">
                                <input
                                    className="form-control"
                                    type="text"
                                    id="lastName"
                                    defaultValue={lastName}
                                    onChange={(e) => this.setState({ lastName: e.target.value })}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="example-text-input" className="col-md-3 col-form-label">{t('ชื่อบริษัท')}</label>
                            <div className="col-md-9">
                                <input
                                    className="form-control"
                                    type="text"
                                    id="companyName"
                                    defaultValue={companyName}
                                    onChange={(e) => this.setState({ companyName: e.target.value })}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="example-text-input" className="col-md-3 col-form-label">Line API Token</label>
                            <div className="col-md-9">
                                <input
                                    className="form-control"
                                    type="text"
                                    id="lineApiToken"
                                    defaultValue={lineApiToken}
                                    onChange={(e) => this.setState({ lineApiToken: e.target.value })}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-3 col-form-label" />
                            <label className="col-md-9">
                                <input type="checkbox" checked={isSendDailyReport} onChange={this.handleCheckSendDailyReport} /> {t('ส่งสรุปรายงานประจำวัน')}
                            </label>
                        </div>
                        </form>
                    </div>

                    <div className="col-md-6">
                        <form>
                        <div className="form-group row">
                            <label htmlFor="example-text-input" className="col-md-3 col-form-label">{t('เบอร์โทรศัพท์')}</label>
                            <div className="col-md-9">
                                <textarea
                                    className="form-control"
                                    id="telephone"
                                    rows={3}
                                    value={telephone}
                                    onChange={(e) => this.onChangeTelePhone(e)} />
                                <span>หากต้องการใส่หลายเบอร์ให้คั่นด้วย , (ลูกน้ำ)</span>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="example-text-input" className="col-md-3 col-form-label">{t('อีเมล์')}</label>
                            <div className="col-md-9">
                                <textarea
                                    className="form-control"
                                    id="email"
                                    rows={3}
                                    value={email}
                                    onChange={(e) => this.onChangeEmail(e)} />
                                <span>หากต้องการใส่หลายอีเมล์ให้คั่นด้วย , (ลูกน้ำ)</span>
                            </div>
                        </div>
                        <hr />
                            <div className="form-group row">
                                <label htmlFor="example-text-input" className="col-md-3 col-form-label"><strong>{t('รหัสผ่านเดิม')}*</strong></label>
                                <div className="col-md-9">
                                    <input className="form-control" type="password" id="example-text-input" />
                                </div>
                            </div>


                        </form>
                    </div>
                </div>
                <hr />

            { showModalChangePassword &&
                <ModalConfirmPassword
                    onClickConfirmChangePassword={this.onClickConfirmChangePassword}
                    onClickCancelChangePassword={this.onClickCancelChangePassword}
                />
            }

            <div className="col-md-12 ">
                <div className="text-right">
                    <button type="submit" className="btn btn-primary" style={{marginTop:3}} onClick={this.handleSubmitChangePassword} >{t('เปลี่ยนรหัสผ่าน')}</button>
                    &nbsp;&nbsp;
                    <button type="submit" className="btn btn-primary" style={{width:125,marginTop:3}} onClick={() => this.onClickConfirmUserInformation()}>{t('บันทึกข้อมูล')}</button>
                    &nbsp;&nbsp;
                </div>
            </div>
        <br />
        </div>
    </div>
    );
  }
}

UserInfomation.propTypes = {
    userLevel: PropTypes.number.isRequired,
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired
}


export default withNamespaces('Menubar')(UserInfomation);



// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/UserInformation.js